import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { digitsAndLetters, digitsOnly } from 'helpers/fieldNormalizers';
export const setDecimalsOnNumber = ({ fixedDecimalScale = false, maxDecimalScale, minDecimalScale = 2, number, separator = '.', }) => {
    if (number === undefined) {
        return null;
    }
    const strNumber = number.toString();
    const [integerPart, decimalPart] = strNumber.split(separator);
    let updatedDecimalPart = decimalPart || '';
    if (maxDecimalScale) {
        updatedDecimalPart = updatedDecimalPart.slice(0, maxDecimalScale).padEnd(maxDecimalScale, '0');
    }
    if (fixedDecimalScale) {
        return `${integerPart}${separator}${updatedDecimalPart}`;
    }
    updatedDecimalPart = updatedDecimalPart.replace(/0+$/, '');
    const finalDecimal = updatedDecimalPart.padEnd(minDecimalScale, '0');
    if (finalDecimal) {
        return `${integerPart}${separator}${finalDecimal}`;
    }
    return integerPart;
};
export function formatWithPattern(str, format) {
    if (!format) {
        return str;
    }
    let formattedString = '';
    let j = 0;
    for (let i = 0; i < str.length; i += 1) {
        while (format[j] && format[j] !== '#') {
            formattedString += `${format[j]}`;
            j += 1;
        }
        if (!format[j]) {
            break;
        }
        formattedString += str[i];
        j += 1;
    }
    while (formattedString.substr(0, 1) === '-') {
        formattedString = formattedString.substr(1);
    }
    while (formattedString.substr(-1) === '-') {
        formattedString = formattedString.slice(0, -1);
    }
    return formattedString;
}
export const formatAsEIN = (num) => formatWithPattern(digitsOnly(String(num)), '##-#######');
export const formatAsGIIN = (num) => {
    if (!num) {
        return '';
    }
    return formatWithPattern(digitsAndLetters(String(num)), '######.#####.##.###');
};
export const formatAsInternationalPhoneNumber = (phoneNumber) => formatPhoneNumberIntl(phoneNumber.number);
export const formatAsSSN = (num) => formatWithPattern(digitsOnly(String(num)), '###-##-####');
export const unformatNumber = (value, returnEmptyString = false) => {
    if (Array.isArray(value)) {
        return value.map((val) => {
            return unformatNumber(val);
        });
    }
    if (value === '' && returnEmptyString) {
        return '';
    }
    const normalizedValue = String(value || '0.00 USD');
    const match = normalizedValue?.match(/[\d,]+(?:\.\d+)?/);
    if (!match) {
        return 0;
    }
    const unformatted = parseFloat(match[0].replace(/,/g, ''));
    return Number.isNaN(unformatted) ? 0 : unformatted;
};
export const formatNumber = (num, options = {}) => {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: options.precision ?? 0,
        maximumFractionDigits: options.precision ?? 0,
    });
    return formatter
        .formatToParts(num)
        .map((part) => {
        if (part.type === 'group') {
            return options.thousand ?? part.value;
        }
        if (part.type === 'decimal') {
            return options.decimal ?? part.value;
        }
        return part.value;
    })
        .join('');
};
